import { defineAsyncComponent } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Dashboards › P&D tecnológico.
 *
 * `ConsoleLayout` DIRETO (como a fila do Service Desk e os Relatórios): a tela
 * é 100% design system console, e o `FullLayout` traria a moldura Vuetify por
 * fora. Assíncrono porque um import estático puxaria o CSS do DS para o bundle
 * de entrada.
 *
 * ⚠ `/dashboards/pd-tecnologico` é ROTA RESTRITA (utils/restrictedRoutes.ts e
 * api/src/constants/restrictedRoutes.ts): sem concessão explícita em
 * /permissions ninguém entra, NEM o admin master. Tela negando acesso é o
 * comportamento correto, não bug — o placar expõe custo de licença por
 * usuário, economia com SaaS e incidentes por sistema.
 */
const ConsoleLayout = defineAsyncComponent(() => import('@/layouts/console/ConsoleLayout.vue'));

export const dashboardsRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboards/pd-tecnologico',
    component: ConsoleLayout,
    meta: { requiresAuth: true, title: 'P&D tecnológico - Hub AtlanGlobal' },
    children: [
      {
        path: '',
        name: 'DashboardsPdTecnologico',
        component: () => import('@/views/Dashboards/PdTecnologico/PdPlacarPage.vue'),
        meta: { requiresAuth: true, title: 'P&D tecnológico', breadcrumb: 'P&D tecnológico' },
      },
      /**
       * ⚠ Rota de permissão PRÓPRIA (`/dashboards/pd-tecnologico/configuracoes`,
       * nível `admin`, migration 295) — não herda o `member`/`editor` do
       * placar. E ela precisa existir AQUI para o `syncFrontendRoutes` do login
       * do admin master mantê-la ativa: o sync desativa toda rota do catálogo
       * que não está na árvore do router, e foi por isso que a linha da
       * migration nasceu `is_active = 0` no banco de dev.
       */
      {
        path: 'configuracoes',
        name: 'DashboardsPdTecnologicoConfig',
        component: () => import('@/views/Dashboards/PdTecnologico/configuracoes/PdConfigPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'P&D tecnológico — configuração',
          breadcrumb: 'Configuração',
        },
      },
    ],
  },
];

export default dashboardsRoutes;
